import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "detailsModal",
  tabindex: "-1",
  "aria-labelledby": "detailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable sales-details-dialog" }
const _hoisted_3 = { class: "modal-content border-0 shadow-lg" }
const _hoisted_4 = { class: "modal-header border-0 pb-0" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = { class: "ms-auto d-flex align-items-center gap-2" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "modal-body pt-4"
}
const _hoisted_11 = { class: "row g-3 mb-4" }
const _hoisted_12 = { class: "col-md-3 col-sm-6" }
const _hoisted_13 = { class: "summary-card" }
const _hoisted_14 = { class: "summary-label" }
const _hoisted_15 = { class: "col-md-3 col-sm-6" }
const _hoisted_16 = { class: "summary-card" }
const _hoisted_17 = { class: "summary-label" }
const _hoisted_18 = { class: "text-success" }
const _hoisted_19 = { class: "col-md-3 col-sm-6" }
const _hoisted_20 = { class: "summary-card" }
const _hoisted_21 = { class: "summary-label" }
const _hoisted_22 = { class: "text-warning" }
const _hoisted_23 = { class: "col-md-3 col-sm-6" }
const _hoisted_24 = { class: "summary-card" }
const _hoisted_25 = { class: "summary-label" }
const _hoisted_26 = { class: "row g-4" }
const _hoisted_27 = { class: "col-lg-7" }
const _hoisted_28 = { class: "details-panel mb-4" }
const _hoisted_29 = { class: "panel-header" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = { class: "text-muted mb-0" }
const _hoisted_32 = { class: "col-lg-5" }
const _hoisted_33 = { class: "details-panel mb-4" }
const _hoisted_34 = { class: "panel-header" }
const _hoisted_35 = { class: "mb-1" }
const _hoisted_36 = { class: "text-muted mb-0" }
const _hoisted_37 = { class: "payment-list" }
const _hoisted_38 = { class: "fw-semibold" }
const _hoisted_39 = { class: "text-muted small" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = { class: "fw-semibold" }
const _hoisted_43 = { class: "payment-actions mt-2" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  class: "payment-empty-state"
}
const _hoisted_47 = { class: "mb-2" }
const _hoisted_48 = { class: "text-muted mb-0" }
const _hoisted_49 = {
  key: 0,
  class: "details-panel"
}
const _hoisted_50 = { class: "panel-header" }
const _hoisted_51 = { class: "mb-1" }
const _hoisted_52 = { class: "text-muted mb-0" }
const _hoisted_53 = { class: "row g-3" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-label" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-label" }
const _hoisted_58 = { value: null }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "col-12" }
const _hoisted_61 = { class: "form-label" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "col-12" }
const _hoisted_64 = { class: "form-label" }
const _hoisted_65 = ["placeholder"]
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_69 = { class: "details-panel mt-4" }
const _hoisted_70 = { class: "mb-3" }
const _hoisted_71 = { class: "totals-row" }
const _hoisted_72 = { class: "totals-row" }
const _hoisted_73 = { class: "totals-row" }
const _hoisted_74 = { class: "totals-row" }
const _hoisted_75 = { class: "totals-row grand" }
const _hoisted_76 = {
  key: 1,
  class: "modal-body py-5 text-center"
}
const _hoisted_77 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_78 = { class: "visually-hidden" }
const _hoisted_79 = { class: "modal-footer border-0 pt-0" }
const _hoisted_80 = {
  type: "button",
  class: "btn btn-dark px-4",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SaleReceipt = _resolveComponent("SaleReceipt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.sale)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge sales-status-badge mb-2", _ctx.statusClass(_ctx.sale.status)])
                }, _toDisplayString(_ctx.formatStatus(_ctx.sale.status)), 3),
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t("sales_page.sale_label")) + " " + _toDisplayString(_ctx.sale.reference_no), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.sale.customer_name || _ctx.sale.customer?.name || _ctx.$t("sales_page.walk_in_customer")) + " • " + _toDisplayString(_ctx.sale.warehouse_name || _ctx.sale.warehouse?.name || _ctx.$t("sales_page.not_available_short")) + " • " + _toDisplayString(_ctx.formatDate(_ctx.sale.created_at || _ctx.sale.date)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.sale)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary btn-sm d-flex align-items-center gap-1",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printReceipt && _ctx.printReceipt(...args)))
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ri-printer-line" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("sales_page.print")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close shadow-none",
              "data-bs-dismiss": "modal",
              "aria-label": _ctx.$t('common.close')
            }, null, 8, _hoisted_9)
          ])
        ]),
        (_ctx.sale)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("sales_page.grand_total")), 1),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.formatCurrency(_ctx.sale.grand_total)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("sales_page.paid")), 1),
                    _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.formatCurrency(_ctx.sale.paid)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("sales_page.balance_due")), 1),
                    _createElementVNode("h5", _hoisted_22, _toDisplayString(_ctx.formatCurrency(_ctx.balanceDue)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("sales_page.payment_status")), 1),
                    _createElementVNode("h5", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge payment-status-badge", _ctx.paymentStatusClass(_ctx.sale.payment_status)])
                      }, _toDisplayString(_ctx.formatStatus(_ctx.sale.payment_status)), 3)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.$t("sales_page.sale_receipt")), 1),
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("sales_page.review_sale_items")), 1)
                      ])
                    ]),
                    _createVNode(_component_SaleReceipt, { sale: _ctx.sale }, null, 8, ["sale"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.$t("sales_page.payment_activity")), 1),
                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("sales_page.manage_sale_payments")), 1)
                      ]),
                      (_ctx.balanceDue > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary btn-sm",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startCreatePayment && _ctx.startCreatePayment(...args)))
                          }, [
                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("sales_page.add_payment")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPayments, (payment) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: payment.id,
                          class: "payment-item"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(payment.method?.name || payment.paid_by || _ctx.$t("sales_page.payment")), 1),
                            _createElementVNode("div", _hoisted_39, [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(payment.created_at)) + " ", 1),
                              (payment.note)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, "• " + _toDisplayString(payment.note), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.formatCurrency(payment.amount)), 1),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-light",
                                onClick: ($event: any) => (_ctx.startEditPayment(payment))
                              }, _toDisplayString(_ctx.$t("sales_page.edit")), 9, _hoisted_44),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-danger",
                                onClick: ($event: any) => (_ctx.removePayment(payment))
                              }, _toDisplayString(_ctx.$t("sales_page.delete")), 9, _hoisted_45)
                            ])
                          ])
                        ]))
                      }), 128)),
                      (!_ctx.sortedPayments.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "payment-empty-icon" }, [
                              _createElementVNode("i", { class: "ri-wallet-3-line" })
                            ], -1)),
                            _createElementVNode("h6", _hoisted_47, _toDisplayString(_ctx.$t("sales_page.no_payments_yet")), 1),
                            _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("sales_page.no_payment_activity_yet")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.showPaymentForm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h5", _hoisted_51, _toDisplayString(_ctx.editingPaymentId ? _ctx.$t("sales_page.edit_payment") : _ctx.$t("sales_page.add_payment")), 1),
                            _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.editingPaymentId ? _ctx.$t("sales_page.update_payment_entry") : _ctx.$t("sales_page.record_new_payment")), 1)
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetPaymentForm && _ctx.resetPaymentForm(...args)))
                          }, _toDisplayString(_ctx.$t("common.cancel")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("sales_page.amount")), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.paymentForm.amount) = $event)),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              class: "form-control"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.paymentForm.amount,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("sales_page.method")), 1),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentForm.method_id) = $event)),
                              class: "form-select"
                            }, [
                              _createElementVNode("option", _hoisted_58, _toDisplayString(_ctx.$t("sales_page.select_payment_method")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: method.id,
                                  value: method.id
                                }, _toDisplayString(method.name), 9, _hoisted_59))
                              }), 128))
                            ], 512), [
                              [
                                _vModelSelect,
                                _ctx.paymentForm.method_id,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("sales_page.paid_by")), 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paymentForm.paid_by) = $event)),
                              type: "text",
                              class: "form-control",
                              placeholder: _ctx.$t('sales_page.paid_by_placeholder')
                            }, null, 8, _hoisted_62), [
                              [_vModelText, _ctx.paymentForm.paid_by]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("sales_page.note")), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentForm.note) = $event)),
                              rows: "3",
                              class: "form-control",
                              placeholder: _ctx.$t('sales_page.optional_note')
                            }, null, 8, _hoisted_65), [
                              [_vModelText, _ctx.paymentForm.note]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("button", {
                              class: "btn btn-primary w-100",
                              disabled: _ctx.isSubmittingPayment,
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitPayment && _ctx.submitPayment(...args)))
                            }, [
                              (_ctx.isSubmittingPayment)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_68))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.editingPaymentId ? _ctx.$t("sales_page.update_payment") : _ctx.$t("sales_page.save_payment")), 1)
                            ], 8, _hoisted_67)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("h5", _hoisted_70, _toDisplayString(_ctx.$t("sales_page.sale_totals")), 1),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_page.subtotal")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.sale.total)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_page.discount")), 1),
                      _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.formatCurrency(_ctx.sale.discount || 0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_page.tax")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.sale.tax || 0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_page.shipping")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.sale.shipping || 0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("sales_page.grand_total")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.sale.grand_total)), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t("sales_page.loading_sale_details")), 1)
              ])
            ])),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("button", _hoisted_80, _toDisplayString(_ctx.$t("common.close")), 1)
        ])
      ])
    ])
  ]))
}